import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    introSection: {
        padding: '0px 0px 32px 5px',
    },
    planTitleBox: {
        gap: 8,
    },
    planActiveChip: {
        color: '#000082',
        backgroundColor: '#e6e6f2',
        fontWeight: 600,
        marginTop: 2,
    },
    introDescription: {
        marginTop: 8,
        maxWidth: 600,
    },
    integrationsHeading: {
        marginBottom: 12,
    },
});

export default styles;
export const useStyles = makeStyles(styles);
